
export type restFilterType = ({ term: { [x: string]: string } } | { terms: { [x: string]: string[] } } | { bool: { should: Array<{ terms: { [x: string]: string[] } } | { term: { [x: string]: boolean } }> } })[] | undefined;

export function composeElasticSearchFilters(restFilter: restFilterType, ...raw: (object | undefined)[]): object {
    const filters: object[] = raw.filter(Boolean) as object[];
    if (filters.length === 0) return { match_none: {} };
    // if (filters.length === 1) return filters[0];
    return {
        bool: {
            must: filters,
            ...(restFilter ? { filter: restFilter } : {})
        },
    };
}

